import { useCallback } from "react";

// Used by useQueryParamsActions only. Prod reads window.location; tests mock
// this to useLocation() — see setupTests.tsx.
export const useMockableLocation = () => {
  return useCallback(() => {
    return window.location;
  }, []);
};
